import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './app/routeTree.gen'
import { crearClienteDeConsultas } from './app/consultas'
import { prepararMovil } from './dominio/movil/movil'
import './estilos/index.css'

const clienteDeConsultas = crearClienteDeConsultas()

const enrutador = createRouter({
  routeTree,
  defaultPreload: 'intent',
  // División del código por ruta: el panel administrativo no se descarga para
  // un emisor. Lo hace el plugin de Vite con `autoCodeSplitting`.
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof enrutador
  }
}

const raiz = document.getElementById('raiz')
if (raiz === null) throw new Error('No existe el elemento #raiz en index.html')

// En la app de iOS y Android, la sesión guardada tras la huella se abre antes de pintar: si no, se
// vería un instante la entrada y luego el portal. En el navegador no espera nada.
void prepararMovil({
  navegar: (ruta) => enrutador.history.push(ruta),
  vaciarCache: () => clienteDeConsultas.clear(),
}).finally(() => {
  createRoot(raiz).render(
    <StrictMode>
      <QueryClientProvider client={clienteDeConsultas}>
        <RouterProvider router={enrutador} />
      </QueryClientProvider>
    </StrictMode>,
  )
})
